"use client"

import { useEffect } from "react"

import PageHeading from "src/components/PageHeading"

type ErrorPageProps = {
  error: Error
}

export default function ErrorPage({ error }: ErrorPageProps) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <>
      <PageHeading>Fehler</PageHeading>
      <p>Das hätte nicht passieren sollen...</p>
    </>
  )
}
